import { render, staticRenderFns } from "./ModuleImageGallery.vue?vue&type=template&id=59120496&scoped=true"
import script from "./ModuleImageGallery.vue?vue&type=script&lang=js"
export * from "./ModuleImageGallery.vue?vue&type=script&lang=js"
import style0 from "./ModuleImageGallery.vue?vue&type=style&index=0&id=59120496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59120496",
  null
  
)

export default component.exports